export default function(bounds, item) {
  if (item.stroke && item.opacity !== 0 && item.strokeOpacity !== 0) {
    bounds.expand(item.strokeWidth != null ? +item.strokeWidth : 1);
  }
  return bounds;
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-scenegraph/src/bound/boundStroke.js
// module id = 106
// module chunks = 0